/** Cursor anchors: a pointer is shared relative to the element under it, so it
 *  lands on the same tile for an operator in another view or window size. */

export const VIEWPORT_ANCHOR = "view";

type Rect = { left: number; top: number; width: number; height: number };

export function anchorIdOf(el: Element | null): string | null {
  for (let n: Element | null = el; n; n = n.parentElement) {
    const a = n.getAttribute("data-anchor");
    if (a) return a;
    if (n.tagName === "BUTTON") {
      const label = n.getAttribute("aria-label");
      if (label) return `btn:${label}`;
    }
  }
  return null;
}

const clamp = (v: number) => Math.min(1, Math.max(0, v));

export function relPos(rect: Rect, clientX: number, clientY: number): { x: number; y: number } {
  if (rect.width <= 0 || rect.height <= 0) return { x: 0, y: 0 };
  return {
    x: clamp((clientX - rect.left) / rect.width),
    y: clamp((clientY - rect.top) / rect.height),
  };
}

export function findAnchor(id: string): Element | null {
  const sel = id.startsWith("btn:")
    ? `button[aria-label="${CSS.escape(id.slice(4))}"]`
    : `[data-anchor="${CSS.escape(id)}"]`;
  for (const el of document.querySelectorAll(sel)) {
    const r = el.getBoundingClientRect();
    if (
      r.width > 0 &&
      r.height > 0 &&
      r.bottom > 0 &&
      r.right > 0 &&
      r.top < innerHeight &&
      r.left < innerWidth
    ) {
      return el;
    }
  }
  return null;
}

export function anchorLabel(id: string): string {
  if (id === VIEWPORT_ANCHOR) return "ekran";
  if (id.startsWith("player:")) return "o'yinchi";
  const i = id.indexOf(":");
  return i >= 0 ? id.slice(i + 1) : id;
}
